import { ColumnDef } from "@tanstack/react-table";

import { Lead } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";

import { Badge } from "@/components/ui/badge/badge";
import { Checkbox } from "@/components/ui/checkbox/checkbox";
import { DataTableSearchableColumn } from "@/types/tables";
// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<Lead>[] {
  return [
    {
      id: "select",
      header: ({ table }) => (
        <Checkbox
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
          className="translate-y-[2px]"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
          className="translate-y-[2px]"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span>{row.index + 1}</span>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Name" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("name")}
            </span>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        let search = typeof value === "string" ? value : value?.[0];
        const rowValue = row.getValue(id) as string;

        return rowValue?.toLowerCase()?.includes(search?.toLowerCase());
      },
    },
    {
      accessorKey: "broker",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Broker" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("broker")}
            </span>
          </div>
        );
      },
    },

    {
      accessorKey: "phone",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Phone" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("phone")}
            </span>
          </div>
        );
      },
    },

    {
      accessorKey: "originalStatus",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Lead Status" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <Badge>{row.getValue("originalStatus")}</Badge>
          </div>
        );
      },
    },

    // {
    //   id: "actions",
    //   cell: ({ row }) => <DataTableRowActions row={row} />,
    // },
  ];
}

export const searchableColumns: DataTableSearchableColumn<Lead>[] = [
  {
    id: "name",
    placeholder: "Filter name...",
  },
];
